import { createRoot } from 'react-dom/client'
import './styles.css'
import { TransitionLayout } from './TransitionLayout'

createRoot(document.getElementById('root')).render(<TransitionLayout />);
